
import { defineComponent } from 'vue';
import CompanyLogo from '@/components/Icons/CompanyLogo.vue';
import globalConstants from '@/shared/globalConstants';

export default defineComponent({
    name: 'CompanySelector',
    components: {
        CompanyLogo,
    },
    data(): {
        knightSelected: boolean;
        swiftSelected: boolean;
    } {
        return {
            knightSelected: false,
            swiftSelected: false,
        };
    },
    computed: {
        knightSelectedClass() {
            if (this.knightSelected) return 'selected-knight selected arrow';
            return '';
        },
        swiftSelectedClass() {
            if (this.swiftSelected) return 'selected-swift selected arrow';
            return '';
        },
    },
    methods: {
        knightClicked() {
            this.knightSelected = true;
            this.swiftSelected = false;

            this.$emit('selectCompany', globalConstants.companies.knight);
        },
        swiftClicked() {
            this.swiftSelected = true;
            this.knightSelected = false;

            this.$emit('selectCompany', globalConstants.companies.swift);
        },
    },
});
